import {gsap} from "gsap";
import {Draggable} from "gsap/Draggable";
import {Observer} from "gsap/Observer";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(Draggable, Observer, ScrollTrigger);

export {gsap};
export {Draggable};
export {Observer};
export {ScrollTrigger};
